import BaseApiRequest from "./BaseApiRequest";
import { EXISTINGUSER_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ExistingUser extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  constructor(userDetail) {
    super();
    this.body = userDetail;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(EXISTINGUSER_URL);

  getBody = () => this.body;
}
